import React from 'react';
import { isHelixOnlyHub } from 'utils/helix';
import ErrorScreen from '../errors/ErrorScreen';
import { jsx as _jsx } from "react/jsx-runtime";
function HelixOnlyAccessWrapper(_ref) {
  var children = _ref.children;
  if (!isHelixOnlyHub) {
    return children;
  }
  return /*#__PURE__*/_jsx(ErrorScreen, {
    reason: "NO_ACCESS_TO_CONTENT"
  });
}
export default HelixOnlyAccessWrapper;